import { configureStore } from "@reduxjs/toolkit";
import usersReducer from "./Redux/usersReduce";
import roleReducer from "./Redux/roleReduce";
import typeReducer from "./Redux/typeReduce";
import settingsReducer from "./Redux/settingsReduce";
import notificationReducer from "./Redux/notificationReduce";
import rootBaseReduce from "./Redux/rootBaseReduce";
import annonceReduce from "./Redux/annonceReduce";
import statusReduce from "./Redux/statusReduce";
import commandeReducer from "./Redux/commandeReduce";
import releveNonReduce from "./Redux/releveNonReduce";
import pctReduce from "./Redux/pctReduce";
import ligneImsReducer from "./Redux/ligneImsReduce";
import imsReducer from "./Redux/imsReduce";
import marcheImsReducer from "./Redux/marcheImsReduce";
import grossisteReducer from "./Redux/grossisteReduce";
import proformatReduce from "./Redux/proformaReduce";
export default configureStore({
  reducer: {
    proforma: proformatReduce,
    users: usersReducer,
    status: statusReduce,
    role: roleReducer,
    type: typeReducer,
    settings: settingsReducer,
    notification: notificationReducer,
    rootBase: rootBaseReduce,
    annonce: annonceReduce,
    commande: commandeReducer,
    releveNon: releveNonReduce,
    pct: pctReduce,
    ligneIms: ligneImsReducer,
    marcheIms: marcheImsReducer,
    ims: imsReducer,
    grossiste: grossisteReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false, }),
});
